import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["quantityInput", "requirementsTable", "neededCell", "statusCell", "stockStatus", "submitButton"]

  connect() {
    console.log("Blend fabrication controller connected")
  }

  updateRequirements() {
    const quantity = parseFloat(this.quantityInputTarget.value) || 0
    const rows = this.requirementsTableTarget.querySelectorAll('tr[data-perfume-id]')
    
    let allSufficient = true

    rows.forEach(row => {
      const percentage = parseFloat(row.dataset.percentage)
      const available = parseFloat(row.dataset.available)
      const unit = row.dataset.unit
      
      // Calculate needed quantity
      const needed = (quantity * percentage / 100.0).toFixed(2)
      const sufficient = available >= needed

      if (!sufficient) {
        allSufficient = false
      }

      // Update needed cell
      const neededCell = row.querySelector('.needed-quantity')
      if (neededCell) {
        neededCell.textContent = `${needed} ${unit}`
      }

      // Update status cell
      const statusCell = row.querySelector('.status-cell')
      if (statusCell) {
        if (sufficient) {
          statusCell.innerHTML = '<span class="badge bg-success"><i class="fas fa-check"></i> OK</span>'
          row.className = 'table-success'
        } else {
          statusCell.innerHTML = '<span class="badge bg-danger"><i class="fas fa-times"></i> Insufficient</span>'
          row.className = 'table-danger'
        }
      }
    })

    // Update stock status alert
    if (this.hasStockStatusTarget) {
      if (allSufficient) {
        this.stockStatusTarget.innerHTML = `
          <div class="alert alert-success">
            <i class="fas fa-check-circle"></i>
            All perfumes are available in sufficient quantity
          </div>
        `
      } else {
        this.stockStatusTarget.innerHTML = `
          <div class="alert alert-warning">
            <i class="fas fa-exclamation-triangle"></i>
            Some perfumes are not available in sufficient quantity
          </div>
        `
      }
    }

    // Enable/disable submit button
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !allSufficient
    }
  }
}

